import React from 'react';
import './Divider.scss';

const Divider = () => {
  return <div className="general-divider" />;
};

export default Divider;
